import { Link } from 'gatsby'
import React from 'react'
import styled from 'styled-components'
import mediaQuery from 'styles/mediaQuery'
import { URL_SELL_WITH_FLIP } from '../helpers'

const LinkStyle = styled(Link)`
  width: fit-content;
  background-color: var(--green-main);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 600;
  font-size: 18px;
  line-height: 20px;
  display: flex;
  align-items: center;
  transition: 0.3s;
  & > svg {
    margin-left: 12px;
    fill: var(--green-main);
  }
  ${mediaQuery.tabletMax} {
    justify-content: center;
  }
  &:hover {
    filter: brightness(0.9);
  }
`

const LinkGetStarted = ({ linkLabel }) => (
  <LinkStyle href={URL_SELL_WITH_FLIP} title={linkLabel}>
    {linkLabel}
  </LinkStyle>
)

export default LinkGetStarted
